export default class CostoIntervento{

   Costi;
   ImportTotale;
   Valuta;
   constructor(){}

}